import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const EMPTY = { offers: 0, to_pay: 0, reviews: 0, bookings: 0, total: 0 };

export function useAttention(enabled) {
  const [a, setA] = useState(EMPTY);
  const { pathname } = useLocation();
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!enabled) { setA(EMPTY); return; }
    let alive = true;
    const fetch = () => api.get("/me/attention").then((r) => alive && setA({ ...EMPTY, ...r.data })).catch(() => {});
    fetch();
    const id = setInterval(fetch, 60000);
    const onFocus = () => fetch();
    window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, [enabled, pathname, tick]);
  return { ...a, refresh: () => setTick((t) => t + 1) };
}

export function CountBadge({ n, testid, className = "" }) {
  if (!n) return null;
  return <span className={`min-w-[18px] h-[18px] px-1 inline-flex items-center justify-center rounded-full bg-[#FF6A00] text-black text-[10px] font-black leading-none ${className}`} data-testid={testid}>{n > 9 ? "9+" : n}</span>;
}
